
import { MutationsService } from '@vedicium/object-mutations';
import Vue, { PropType } from 'vue';
import { APP_ERROR_EVENT } from '../../../../../constants';
import { Core } from '../../../../../services/core';

import { FilterPartsStore, FilterPartEntity } from '../../../../../services/parts';
import { PartsFiltersSublinesForm } from '../components';

export default Vue.extend({
  name: 'partsFiltersViewManufacturing',
  components: {
    PartsFiltersSublinesForm,
  },
  props: {
    filter: {
      type: Object as PropType<FilterPartEntity>,
    },
  },
  data() {
    return {
      isLoadingForm: false,

      metadata: {
        filter: JSON.parse(JSON.stringify(this.filter)) as FilterPartEntity,
      },
    };
  },

  methods: {
    onAddSublineClick(): void {
      (this.$refs.sublinesForm as any).onAddSubline();
    },
    async onSublinesUpdate(): Promise<void> {
      try {
        await this.onSubmit();
      } catch (e) {
        this.$set(this.metadata, 'filter', JSON.parse(JSON.stringify(this.filter)));
      }
    },

    async onSubmit() {
      this.$set(this, 'isLoadingForm', true);
      try {
        const mutations = MutationsService.getMutationsByComparison(
          this.filter,
          this.metadata.filter,
          ['manufacturing.sublines'],
        );

        if (mutations.length > 0) {
          const entity = await FilterPartsStore.update(this.filter._meta.guid, mutations);

          this.$emit('update:filter', entity);
          this.$set(this.metadata, 'filter', JSON.parse(JSON.stringify(entity)));
        }

        this.$bvToast.toast('Document successfully updated', {
          title: 'Update successful',
          variant: 'success',
          solid: true,
        });
      } catch (e) {
        Core.Eventhub.emit(APP_ERROR_EVENT, e);
        console.error(e);
        throw e;
      } finally {
        this.$set(this, 'isLoadingForm', false);
      }
    },
  },
});
